import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import ModalAddQuestion from '@/views/components/SimpleTextAdivse/Modals/ModalAddQuestion';
import ModalDeleteQuestion from '@/views/components/SimpleTextAdivse/Modals/ModalDeleteQuestion';
import ModalUAM from '@/views/components/SimpleTextAdivse/Modals/ModalUAM';

import { Button, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList } from '@mui/material';

const ThreeDots = () => (
	<i className='three-dots'>
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			fill='currentColor'
		><path d='M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z' />
		</svg>

	</i>
);

const AdminMenu = ({
	question, getQuestions, setAlert,
}) => {
	const [ showModalAdd, setShowModalAdd ] = useState(false);
	const [ showModalDelete, setShowModalDelete ] = useState(false);
	const [ showModalUAM, setShowModalUAM ] = useState(false);

	const { dict, ppj } = useSelector((state) => state.app);
	const [ open, setOpen ] = useState(false);

	const navigate = useNavigate();

	const anchorRef = useRef(null);

	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event) => {
		if (
			anchorRef.current &&
            anchorRef.current.contains(event.target)
		) {
			return;
		}
		setOpen(false);
	};

	const handleCloseModalDelete = (ev) => {
		handleClose(ev);
		setShowModalDelete(false);
	};

	const handleEditQuestion = () => {
		setShowModalAdd(true);
	};

	const handleDeleteQuestion = () => {
		setShowModalDelete(true);
	};

	const handleUAM = () => {
		setShowModalUAM(true);
	};

	const handleAnswerQuestion = () => {
		navigate(`/simple-text-advice/${question.id}`);
	};

	const handleListKeyDown = (event) => {
		if (event.key === 'Tab') {
			event.preventDefault();
			setOpen(false);
		} else if (event.key === 'Escape') {
			setOpen(false);
		}
	};

	// return focus to the button when we transitioned from !open -> open
	const prevOpen = useRef(open);
	useEffect(() => {
		if (prevOpen.current === true && open === false) {
			anchorRef.current.focus();
		}
		prevOpen.current = open;
	}, [ open ]);

	return (
		<>
			{showModalAdd && <ModalAddQuestion 
				editQuestion={ question }
				// setItemToEdit={ setItemToEdit }
				getQuestion={ getQuestions }
				showModalAdd={ showModalAdd }
				setShowModalAdd={ setShowModalAdd }
				setAlert={ setAlert }
			/>}
			{showModalDelete && 
			<ModalDeleteQuestion 
				showModalDelete={ showModalDelete }
				setShowModalDelete={ setShowModalDelete }
				handleClose={ handleCloseModalDelete }
				getQuestions={ getQuestions }
				id={ question.id }
				setAlert={ setAlert }
			/>}
			{showModalUAM && 
			<ModalUAM
				showModalUAM={ showModalUAM }
				setShowModalUAM={ setShowModalUAM }
				// handleClose={ handleCloseModalDelete }
				getQuestions={ getQuestions }
				question={ question }
				setAlert={ setAlert }
			/>}
			<Button
				ref={ anchorRef }
				id='composition-button'
				aria-controls={ open ? 'composition-menu' : undefined }
				aria-expanded={ open ? 'true' : undefined }
				aria-haspopup='true'
				onClick={ handleToggle }
				className='mui__button'
			>
				{dict.dictionary.list.manage}
				<ThreeDots />
			</Button>
			<Popper
				open={ open }
				anchorEl={ anchorRef.current }
				role={ undefined }
				placement='bottom-start'
				transition
				disablePortal
				className='mui__popper'
			>
				{({ TransitionProps, placement }) => (
					<Grow
						{ ...TransitionProps }
						style={ {
							transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
						} }
					>
						<Paper>
							<ClickAwayListener onClickAway={ handleClose }>
								<MenuList
									autoFocusItem={ open }
									id='composition-menu'
									aria-labelledby='composition-button'
									onKeyDown={ handleListKeyDown }
								>
									<MenuItem
										className='table__menu-item'
										onClick={ handleEditQuestion }
									>
										{dict.simpleTextAdvices.admin.manageMenu.edit}
									</MenuItem>
									<MenuItem
										className='table__menu-item'
										onClick={ handleAnswerQuestion }
									>
										{dict.simpleTextAdvices.admin.manageMenu.answer}
									</MenuItem>
									{ppj?.externalMode && <MenuItem
										className='table__menu-item'
										onClick={ handleUAM }
									>
										{dict.simpleTextAdvices.admin.manageMenu.uam}
									</MenuItem>}
									<MenuItem
										className='table__menu-item'
										onClick={ handleDeleteQuestion }
									>
										{dict.simpleTextAdvices.admin.manageMenu.delete}
									</MenuItem>
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</>
	);
};

export default React.memo(AdminMenu);